import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/user/getters";
import { actions } from "@/store/modules/user/actions";
import { mutations } from "@/store/modules/user/mutations";
import { IUserState, state } from "@/store/modules/user/state";

export const user: Module<IUserState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
